
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'CommonNav',
})
export default class CommonNav extends Vue {
    @Prop({ required: true }) public value!: string;
    // navs
    @Prop({ required: true, type: Array }) public navigations!: Array<ValueText | ExtraClass>;

    @Prop({ type: Boolean, default: true }) public autoWidth!: boolean;

    /**
     * 点击
     */
    public onClick(item: ValueText) {
        this.$emit('input', item.value);
    }
}
